(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["hero"] && !Shopify.designMode) return;
  try {
    
  const connection = navigator.connection || navigator.mozConnection || navigator.webkitConnection;
  const shouldPauseHeroVideo = window.matchMedia('(prefers-reduced-motion: reduce)').matches || connection?.saveData;

  if (shouldPauseHeroVideo) {
    document.querySelectorAll('video[data-hero-autoplay="true"]').forEach((video) => {
      video.removeAttribute('autoplay');
      video.autoplay = false;
      video.preload = 'none';
      video.pause();
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
